// ISO 3166-1 alpha-2, cf. http://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
export enum CountryCode {
  NO = 'NO', // 'Norway', no-NO
  DK = 'DK', // 'Denmark' da-DK
  FI = 'FI', // 'Finland', fi-FI
  SE = 'SE', // 'Sweden' sv-SE
  AL = 'AL', // 'Albania',
  AD = 'AD', // 'Andorra',
  BE = 'BE', // 'Belgium',
  BA = 'BA', // 'Bosnia and Herzegovina',
  BG = 'BG', // 'Bulgaria',
  CY = 'CY', // 'Cyprus',
  EE = 'EE', // 'Estonia',
  FR = 'FR', // 'France',
  GR = 'GR', // 'Greece',
  IE = 'IE', // 'Ireland',
  IS = 'IS', // 'Iceland',
  IT = 'IT', // 'Italy',
  HR = 'HR', // 'Croatia',
  LV = 'LV', // 'Latvia',
  LI = 'LI', // 'Liechtenstein',
  LT = 'LT', // 'Lithuania',
  LU = 'LU', // 'Luxembourg',
  MT = 'MT', // 'Malta',
  MD = 'MD', // 'Moldova',
  MC = 'MC', // 'Monaco',
  ME = 'ME', // 'Montenegro',
  NL = 'NL', // 'Netherlands',
  PL = 'PL', // 'Poland',
  PT = 'PT', // 'Portugal',
  RO = 'RO', // 'Romania',
  RU = 'RU', // 'Russia',
  SM = 'SM', // 'San Marino',
  CH = 'CH', // 'Switzerland',
  RS = 'RS', // 'Serbia',
  SK = 'SK', // 'Slovakia',
  SI = 'SI', // 'Slovenia',
  ES = 'ES', // 'Spain',
  GB = 'GB', // 'United Kingdom',
  CZ = 'CZ', // 'Czech Republic',
  TR = 'TR', // 'Turkey',
  DE = 'DE', // 'Germany',
  UA = 'UA', // 'Ukraine',
  HU = 'HU', // 'Hungary',
  VA = 'VA', // 'Vatican City',
  BY = 'BY', // 'Belarus',
  AT = 'AT', // 'Austria',
  GE = 'GE', // 'Georgia',
}
